import type { Icon, IconProps } from "@phosphor-icons/react";
import clsx from "clsx";

export function addRtlSupport(
  IconComponent: Icon,
): React.ComponentType<IconProps> {
  const PatchedIcon = (props: IconProps) => {
    return (
      <IconComponent
        {...props}
        className={clsx(props.className, "rtl:-scale-x-100")}
      />
    );
  };

  PatchedIcon.displayName = IconComponent.displayName;

  return PatchedIcon;
}
